import React, { useEffect, useState } from 'react'
import API from '../../../../services/API'
import Button from '@mui/material/Button'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import EmployeeSelector from '../../../events/EmployeeSelector'

const EditAccess = ({ loadList, onClose }) => {
  const [selectedStaff, setSelectedStaff] = useState(null)
  const [isCoOrdinator, setIsCoOrdinator] = useState(false)

  // Prefill from the employee's current access so submitting without changing
  // the tick cannot silently strip a Co-Ordinator's permission.
  useEffect(() => {
    setIsCoOrdinator(
      (selectedStaff?.employee?.ptsAccess || []).includes('CoOrdinator'),
    )
  }, [selectedStaff])

  const handleSubmit = (e) => {
    e.preventDefault()
    API.post('/edit-employee-pts-permissions', {
      employee: selectedStaff.employee._id,
      selectedAccess: isCoOrdinator ? ['CoOrdinator'] : [],
    }).then((res) => {
      if (res.status === 200) {
        onClose()
        loadList()
      }
    })
  }

  return (
    <Stack gap={1} component="form" onSubmit={handleSubmit}>
      <Typography variant="title3">Edit PTS Access Permissions</Typography>
      <EmployeeSelector
        value={selectedStaff}
        onChange={(e, newValue) => setSelectedStaff(newValue)}
        label="Staff Member"
        helperText="Select a member of staff to update their PTS permissions"
        additionalSelectors="ptsAccess"
        required
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={isCoOrdinator}
            onChange={(e) => setIsCoOrdinator(e.target.checked)}
            disabled={!selectedStaff}
          />
        }
        label="PTS Co-Ordinator"
      />
      <Typography variant="body2" color="text.secondary">
        Co-Ordinators can manage bookings, planning, dispatch and invoices. All
        employees can work a PTS duty without any extra permission.
      </Typography>
      <Button
        variant="contained"
        fullWidth
        color="anGreen"
        type="submit"
        disabled={!selectedStaff}
      >
        Submit
      </Button>
    </Stack>
  )
}

export default EditAccess
